module.exports = __webpack_public_path__ + "img/arrow_right.d385e8b5.svg";